var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMonsterSpeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3014 25.9818C17.6621 21.3818 15.9122 7.87005 22.0842 6.16197L21.5739 5.55742L4.77288 5.55902C5.13548 18.8844 21.3014 25.9818 21.3014 25.9818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0836 6.16061C15.9115 7.86869 17.6615 21.3805 21.3007 25.9805C21.3007 25.9805 5.13485 18.8831 4.77225 5.55766",
    stroke: "#4905AB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMonsterSpeech);
export default __webpack_public_path__ + "static/media/aiMonsterSpeech.6aa66e410ba3ed18e0655b4c30e5957a.svg";
export { ForwardRef as ReactComponent };